import type { ReactElement } from 'react';
import { SimpleGrid } from '@mantine/core';
import AdoptionMetricCard from './AdoptionMetricCard';
import { DRIVER_ICONS } from './AdoptionDriverIcons';
import type { AdoptionDriver } from './AdoptionTypes';

/**
 * The four adoption drivers as KPI cards: each shows its score against the maturity
 * bands (a "what's good" scale), the 4-week delta, and the weekly trend — computed
 * live from the telemetry OLAP layer via the adoption gateway.
 */
export default function AdoptionDriverTiles({ drivers }: { drivers: AdoptionDriver[] }): ReactElement {
    return (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
            {drivers.map((driver) => (
                <AdoptionMetricCard key={driver.key} driver={driver} icon={DRIVER_ICONS[driver.key]} />
            ))}
        </SimpleGrid>
    );
}
